import { Component, OnInit, EventEmitter, Input, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { Location } from "@angular/common";

import { MyAuthService } from "../../auth.service";
import { ApiService } from "../../../services/api.service";
import { SharedService } from "../../../services/shared.service";
//import { AuthService } from "angularx-social-login";
import { SocialUser } from "angularx-social-login";
//import { GoogleLoginProvider } from "angularx-social-login";

@Component({
  selector: "app-partner-login",
  templateUrl: "./partner-login.component.html",
  styleUrls: ["./partner-login.component.scss"]
})
export class PartnerLoginComponent implements OnInit {
  public loginForm: FormGroup;
  public isSubmitted = false;
  public isError = false;
  public errorMsg = "";
  //public regType = 0;
  user: SocialUser;
  public showLogin = true;
  public loginSuccess = false;
  public loginEmail = "";
  public passwordType = "password";
  public successMsgTitle =
    "Thank you for your interest! We will get back to you shortly.";
  public userInfo;
  @Input() showModal = false;
  @Output() hideLogin = new EventEmitter<string>();
  @Output() showForgotPasswordBox = new EventEmitter<number>();

  constructor(
    public formBuilder: FormBuilder,
    private _location: Location,
    private authService: MyAuthService,
    //private socialAuth: AuthService,
    private router: Router,
    private _shared: SharedService,
    private apiService: ApiService
  ) {
    this.authService.userData.subscribe(userData => {
      if (userData) {
        this.userInfo = userData;
        console.log("Logged redirect");
        this.router.navigate(["user/my-dashboard"]);
      } else {
        // this.router.navigate(['/']);
      }
    });
    /* this._shared.getRegistrationType.subscribe(regType => {
      console.log(regType);
      this.regType = regType;
    }); */
    this._shared.getLoginOrRegister.subscribe(type => {
      console.log(type);
      // this.toOpen = regType;
      this.showLogin = type === 1 ? true : false;
    });
  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      email: ["", [Validators.email, Validators.required]],
      password: ["", Validators.required]
      //subscribe: this.regType === 2 ? true : false
    });
    /* this.socialAuth.authState.subscribe(user => {
      this.user = user;
      console.log("User", this.user);
    }); */
  }
  get formControls() {
    return this.loginForm.controls;
  }

  partnerLogin() {
    console.log(this.loginForm.value);
    this.isSubmitted = true;
    if (this.loginForm.invalid) {
      // this.isSubmitted = false;
      return;
    }
    console.log("loginForm >>>", this.loginForm.value);
    //return;
    /* const res = {
        "access_token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTc1NTYxMTEzOSwianRpIjoiNGE3ZWQ4MTctMjAyMy00ZjVkLWFmMDMtNGU2NjZlY2Q3YzNhIiwibmJmIjoxNzU1NjExMTM5LCJ0eXBlIjoiYWNjZXNzIiwic3ViIjp7Il9pZCI6IjY4YTQwZjU1YzM2Nzc3ZjE4ZjQwNjI2ZSIsInBfaWQiOiJwXzEiLCJlbWFpbCI6ImpvaG5kb2VAZ21haWwuY29tIiwiZmlyc3RfbmFtZSI6IkpvaG4iLCJsYXN0X25hbWUiOiJEb2UiLCJtb2JpbGVfbnVtYmVyIjoiOTQyNjUyODk4OSIsImFkZHJlc3MiOiJCLTExMSwgQWRkcmVzcywgQWhtZWRhYmFkIn0sImV4cCI6MTc1NTYzOTkzOX0.3jGljyTuGEH32wibudNjRKsmO5o3rsYQY6F5W7U5HuM",
        "refresh_token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTc1NTYxMTEzOSwianRpIjoiMmY5MzIyMDEtY2RhOS00N2IzLTkwZDItMzhhNjZhOTMyNGM4IiwibmJmIjoxNzU1NjExMTM5LCJ0eXBlIjoicmVmcmVzaCIsInN1YiI6eyJfaWQiOiI2OGE0MGY1NWMzNjc3N2YxOGY0MDYyNmUiLCJwX2lkIjoicF8xIiwiZW1haWwiOiJqb2huZG9lQGdtYWlsLmNvbSIsImZpcnN0X25hbWUiOiJKb2huIiwibGFzdF9uYW1lIjoiRG9lIiwibW9iaWxlX251bWJlciI6Ijk0MjY1Mjg5ODkiLCJhZGRyZXNzIjoiQi0xMTEsIEFkZHJlc3MsIEFobWVkYWJhZCJ9LCJleHAiOjE3NTgyMDMxMzl9.1a70vKR6g8ipoSPIuTSXfjNJ0YNMwt-w35xHbDdzhlM"
    }
    this.authService.login(res);
    this.isError = false;
    this.errorMsg = "";
    this.loginEmail = this.loginForm.value.email; */
    //return;
    // this.authService.login(this.loginForm.value);
    this.apiService.partnerAuth(this.loginForm.value).subscribe(
      res => {
        console.log("api response", res);
        let nRes = res;
        nRes.access_token = res.access_token+"123";
        if (res.access_token) {
          this.authService.login(nRes);
          this.isError = false;
          this.errorMsg = "";
          this.loginEmail = this.loginForm.value.email;
          this.loginSuccess = true;
          /* if (this.regType === 2) {
            this.loginSuccess = true;
          } else {
            this.close("");
            // this.router.navigateByUrl('/user/my-dashboard/watchlist');
            // this.router.navigate(['my-dashboard']);
          } */
        } else {
          this.isSubmitted = false;
          this.isError = true;
          this.errorMsg = res.msg;
        }
      },
      err => {
        console.log(err);
        // if (err.error && err.error.status_code === 401) {
        if (err.error) {
          this.isSubmitted = false;
          this.isError = true;
          this.errorMsg = "Please try again later!";
        }
      }
    );
  }

  /* signInWithGoogle(): void {
    // this.isSubmitted = true;
    this.socialAuth.signIn(GoogleLoginProvider.PROVIDER_ID).then(userData => {
      console.log("result ", userData);
      const subscribe = this.regType === 2 ? true : false;
      this.apiService
        .socialSignIn({
          provider: "google",
          id_token: this.user.idToken,
          subscribe: subscribe
        })
        .subscribe(
          result => {
            console.log("api response", result);
            if (result.access_token) {
              this.authService.login(result);
              this.loginEmail = userData.email;
              this.isError = false;
              if (this.regType === 2) {
                this.loginSuccess = true;
              } else {
                // this.close('');
                // this.router.navigate(['my-dashboard']);
              }
            } else {
              // this.isSubmitted = false;
              this.isError = true;
              this.errorMsg = result.msg;
            }
          },
          err => {
            console.log(err);
            if (err.error) {
              this.isSubmitted = false;
              this.isError = true;
              this.errorMsg = "Please try again later!";
            }
          }
        );
    });
  } */

  signOut(): void {
    //this.socialAuth.signOut();
  }
  goBack() {
    this._location.back();
  }

  toggleLogin() {
    console.log("Register");
    // this.router.navigate(['authentication/register']);
    this.showLogin = !this.showLogin;
  }

  close(email) {
    // console.log('closemodal')
    // if (this.regType === 2 && (this.userInfo && (this.userInfo.identity.role === 3 || this.userInfo.identity.role === 2)
    //   && !this.userInfo.identity.mobile_confirmed)) {
    //   this._shared.toggleMobileVerify(email);
    // }
    this.hideLogin.emit("false");
  }

  goToForgotPassword() {
    console.log("forgot pass");
    this.showForgotPasswordBox.emit(1);
  }

  showPassword() {
    this.passwordType = this.passwordType === "password" ? "text" : "password";
  }
}
